import { isOnlyLocalhost } from '@/utils/system';
import type { StateCreator } from 'zustand';

export const zustandLogger =
  (storeName: string) =>
  <T extends object>(config: StateCreator<T>) =>
  (
    set: Parameters<StateCreator<T>>[0],
    get: Parameters<StateCreator<T>>[1],
    api: Parameters<StateCreator<T>>[2],
  ): T => {
    const store = config(set, get, api);

    // ローカルホスト以外ではそのまま返す。
    if (!isOnlyLocalhost()) {
      return store;
    }

    const wrapFunctions = <Obj extends object>(
      obj: Obj,
      path: string[] = [],
    ): Obj => {
      return Object.fromEntries(
        Object.entries(obj).map(([key, val]) => {
          const currentPath = [...path, key];
          if (typeof val === 'function') {
            const wrappedFn = (...args: any[]) => {
              const prev = get();
              // biome-ignore lint/complexity/noBannedTypes: <explanation>
              const result = (val as Function)(...args);
              const next = get();
              // biome-ignore lint/suspicious/noConsole:
              console.groupCollapsed(
                `%c[Zustand][${storeName}] ${currentPath.join('.')}`,
                'color: #03a9f4; font-weight: bold;',
              );
              // biome-ignore lint/suspicious/noConsole:
              console.log('args:', args);
              // biome-ignore lint/suspicious/noConsole:
              console.log('prev:', prev);
              // biome-ignore lint/suspicious/noConsole:
              console.log('next:', next);
              // biome-ignore lint/suspicious/noConsole:
              console.groupEnd();
              return result;
            };
            return [key, wrappedFn];
          }
          if (val && typeof val === 'object' && !Array.isArray(val)) {
            return [key, wrapFunctions(val as object, currentPath)];
          }
          return [key, val];
        }),
      ) as Obj;
    };

    return wrapFunctions(store) as T;
  };
